customElements.get("localization-form") || customElements.define("localization-form", class extends HTMLElement {
  constructor() {
    super(), this.modal = this.closest(".modal"), this.modalToggle = this.modal.querySelector('input[type="checkbox"][data-locker]'), 
    this.form = this.querySelector("form"), this.data = JSON.parse(this.modal.querySelector("script[data-json]").textContent || "[]") || {}, 
    this.currentStore = this.dataset.storeCode;
  }
  async connectedCallback() {
    await ((e, t = 5e3) => new Promise(((a, o) => {
      const s = Date.now(), i = setInterval((() => {
        window[e] ? (clearInterval(i), a(window[e])) : Date.now() - s >= t && (clearInterval(i), 
        o(new Error(`'${e}' did not become available within ${t}ms.`)));
      }), 100);
    })))("Geo", 5e3), this.form && window.Geo && this.modal && this.addEventListeners();
  }
  update() {
    const e = this.querySelector('[name="country_code"]').selectedOptions[0];
    if (!e) return void this.form.submit();
    this.querySelector("[data-name]") && (this.querySelector("[data-name]").textContent = e.textContent), 
    this.querySelector("[data-flag]") && (this.querySelector("[data-flag]").src = this.querySelector("[data-flag]").src.replace(/([a-z]{2})\.svg$/, `${e.value.toLowerCase()}.svg`)), 
    this.modal.querySelectorAll("[data-country-code]").forEach((t => {
      t.textContent = e.value;
    })), this.modal.querySelectorAll("[data-country-name]").forEach((t => {
      const a = this.data[e.value];
      a && (t.textContent = a?.name);
    }));
    const t = this.modal.querySelector("[data-usp-code].active");
    t && (t.classList.add("hidden"), t.classList.remove("active"));
    const a = this.modal.querySelector(`[data-usp-code="${e.value}"]`);
    a && (a.classList.remove("hidden"), a.classList.add("active"));
  }
  addEventListeners() {
    this.modal.addEventListener("click", (e => {
      e.stopImmediatePropagation();
    })), this.form.addEventListener("change", (() => {
      this.update();
    })), this.form.addEventListener("submit", (e => {
      e.preventDefault(), this.form.submit();
    })), this.modalToggle && this.modalToggle.addEventListener("change", (() => {
      this.modalToggle.checked || document.body.classList.remove("attentive-hide");
    }));
  }
});